import _ from 'lodash';
import moment from 'moment';

class InvoiceEditTimeEntryModalController {
  constructor($scope, $uibModalInstance, $http, AuthenticationService) {
      "ngInject";
      this.name = 'ConfirmModal';

      $scope.title = $uibModalInstance.title;
      $scope.subject = $uibModalInstance.subject;
      $scope.message = $uibModalInstance.message;

      $scope.invoice = $uibModalInstance.invoice;

      $scope.userId = $uibModalInstance.userId;
      $scope.chargeCodeId = $uibModalInstance.chargeCodeId;

      $scope.employee = $uibModalInstance.employee;
      $scope.chargeCode = $uibModalInstance.chargeCode;
      $scope.lineItem  = $uibModalInstance.lineItem;
      $scope.uninvoicedEntries = $uibModalInstance.uninvoicedEntries;

      $scope.timeEntries = $uibModalInstance.timeEntries;
      $scope.apiHost = $uibModalInstance.apiHost;
      $scope.showBillableRate = AuthenticationService.hasPermission('PERM_VIEW_CHARGE_CODE_RATE_INFORMATION')
        && ($scope.timeEntries || []).some((entry) => entry.billableRate != null);

      $scope.currency = function (value) {
        if (value == null) {
          return '—';
        }
        return '$' + Number(value).toFixed(2);
      };

      $scope.updateInvoice = function () {
        let x = _.filter($scope.timeEntries, (obj) => {
          return obj.selected;
        });


        $http.put($scope.apiHost+"/api/admin/invoices/"+$scope.invoice.id+"/lineitems/"+$scope.lineItem.id+"/timeentries", x, {withCredentials: true}).then(function (success) {
          $uibModalInstance.invoice = success.data;
          $uibModalInstance.success();
        }, function (failure) {
          // self.toastr.error("Could not update time entries.", "ERROR");
        });

      };

      $scope.cancel = function () {
        $uibModalInstance.cancel();
      };

      $scope.selectAll = function() {
        $scope.allSelected = !$scope.allSelected;
        $scope.timeEntries.forEach((entry) => {
          entry.selected = $scope.allSelected;
        });
      };

      $scope.getTotalHours = function() {
        let hours = 0;
        if($scope.timeEntries) {
          $scope.timeEntries.forEach((entry) => {
            hours += entry.hours;
          });
        }
        return hours;
      };

      $scope.timeEntries.forEach(function (timeEntry){
        if(timeEntry.invoiceLineItemId && timeEntry.invoiceLineItemId !== null) {
          timeEntry.selected = true;
        }
      });

        // let entriesForEmployee = _.filter($scope.uninvoicedEntries, (obj) => {
        //   let x = obj.employeeId == $scope.userId;
        //   let y = obj.chargeCode.id == $scope.chargeCodeId;
        //   let z = moment(obj.date).isSameOrAfter($scope.invoice.invoicePeriodStart) && moment(obj.date).isSameOrBefore($scope.invoice.invoicePeriodEnd)
        //   return x && y && z;
        // });
        //
        // if($scope.lineItem.timeEntries) {
        //   //for each entry
        //   $scope.lineItem.timeEntries.forEach((entry) => {
        //     entriesForEmployee.forEach((obj) => {
        //       let x = obj.date == entry.date && obj.hours == entry.hours && obj.chargeCode.id == entry.chargeCode.id;
        //       if(x) {
        //         obj.selected = true;
        //       }
        //     });
        //   });
        // }
        //
        // $scope.timeEntries = entriesForEmployee;



  }





}

export default InvoiceEditTimeEntryModalController;



// WEBPACK FOOTER //
// ./client/common/modals/InvoiceEditTimeEntryModal/invoiceEditTimeEntryModal.controller.js